export default "__VITE_ASSET__DSoF_v3l__"